import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/CorporateScenarios/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CorporateScenariosQueries extends VueCqrs
{
	runScenariosPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildScenariosPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runSettingsPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string | null)
	{
		const query = q.buildSettingsPageQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runPortfoliosPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const query = q.buildPortfoliosPageQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runProjectsPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const query = q.buildProjectsPageQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runSchedulingPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const query = q.buildSchedulingPageQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runPnlPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const query = q.buildPnlPageQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runSchedulingSettingsQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const query = q.buildSchedulingSettingsQueryV1(workspaceId, strategyId, scenarioId);
		this.$query(query);
	}

	runCorporateScenarioPnlQueryV1(workspaceId: number, strategyId: string, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: string)
	{
		const query = q.buildCorporateScenarioPnlQueryV1(workspaceId, strategyId, scenarioId, applyBenefitsConfidenceFactor, pnlTemplateId, denomination);
		this.$query(query);
	}
}